import SearchImg from 'assets/icons/search.svg';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';
import { Container, Content, SearchmgStyled, TextWarning } from './styles';

export const NoItemsFound = () => {
  return (
    <Container>
      <Content>
        <SearchmgStyled src={SearchImg} alt="Search img" />
        <TextWarning>
          <HeadlineSmall> Desculpe, não encontramos nenhum resultado.</HeadlineSmall>
        </TextWarning>
      </Content>
    </Container>
  );
};
